export function spotlightModuleCard(card, index) {
  return `<li class="splide__slide spotlight-slide card__item" data-ht-component="spotlight-card" data-meta-index="${index}">
                <div class="tile__image">
                  ${card.link != '' ? '<a class="tile__image-link" href="' + card.link.link.trim() : ''}${card.link.target == 'true' ? '" target="_blank">' : '">'}
                  <picture>
                   <img src="${card.image.copy}" />
                  </picture>
                  ${card.link != '' ? '</a>' : ''}
                </div>
                <div class="tile__caption">
                  ${card.title.enable ? '<p class="t2 card__caption">' + card.title.copy + '</p>' : ''}
                  ${card.copy.enable ? '<span class="p1 card__subcopy"><p>' + card.copy.copy + '</p></span>' : ''}
                  ${card.cta.enable && card.link.target == 'true' ? '<div class="slider__button"> <a class="button button--secondary" data-ht-element="cta" target="_blank" href="' + card.link.link + '">' + card.cta.copy + '</a></div>' : ''}
                  ${card.cta.enable && card.link.target != 'true' ? '<div class="slider__button"> <a class="button button--secondary" data-ht-element="cta" href="' + card.link.link + '">' + card.cta.copy + '</a></div>' : ''}
                </div>
              </li>`;
}

export function spotlightModuleHeader(data) {
  const textClass = data.general.controls.title.alt_font !== '' ? data.general.controls.title.alt_font : 't1';
  return `${data.general.controls.title.enable ? '<h2 class="' + textClass + ' header__headline" data-source="dy">' + data.general.controls.title.copy + '</h2>' : ''}
             ${data.general.controls.caption.enable && textClass.includes('t1') ? '<p class="p4 header__subcopy">' + data.general.controls.caption.copy + '</p>' : ''}
             <div class="splide__arrows"></div>`;
}

export function primaryModuleLogo(image_url) {
  return `<picture>
            <source media="(max-width: 432px)"
                    srcset="${image_url} 1024w">
            <source media="(min-width: 433px)"
            srcset="${image_url} 1024w">
              <img src="${image_url}"
                    alt="Primary Hero Logo"/>
              </picture>`;
}
export function primaryModuleImage(image_url) {
  return `<picture>
            <source class="media--desktop media--eight-nine" media="(max-width: 432px)"
                    srcset="">
            <source class="media--desktop media--sixteen-nine" media="(min-width: 433px)"
            srcset="">
            <img src="${image_url}"
                  alt="Primary Hero Image"/>
              </picture>`;
}

export function primaryModuleVideo(video_17_8, video_16_9, video_8_9, image_17_8, image_16_9, image_8_9, layout, controls) {
  const desktopImage = image_17_8 || video_16_9;
  const desktopVideo = video_17_8 || video_16_9;
  return `<div class="media--video media--desktop">
            <video ${controls ? 'controls' : ''} playsinline="playsinline" autoplay="autoplay" loop="loop" muted="muted" preload="metadata" poster="${layout == 'fullscreen' ? image_16_9 : image_8_9}">
              <source src="${layout == 'fullscreen' ? desktopVideo : video_8_9}" type="video/mp4">
            <img src="${layout == 'fullscreen' ? desktopImage : image_8_9}" alt="Primary Hero Poster Desktop" ></video>
            </div>
          <div class="media--video media--mobile">
            <video ${controls ? 'controls' : ''} playsinline="playsinline" autoplay="autoplay" loop="loop" muted="muted" preload="metadata" aria-label="Primary Hero Video" poster="${image_8_9}">
            <source src="${video_8_9}" type="video/mp4">
            <img src="${image_8_9}" alt="Primary Hero Poster Mobile"></video>
          </div>`;
}

export function stlHotspot(data) {
  function getMeasurementUnits(position) {
    return `${position}%`;
  }
  return `
	  <div class="stl--hotspot" aria-label="${data.hotspot_title}" data-ht-element="stl-touchpoint-${data.index}" style="position:absolute; --hotspot-desktop-top:${getMeasurementUnits(data.hotspot_top_desktop)}; --hotspot-desktop-left:${getMeasurementUnits(data.hotspot_left_desktop)}; --hotspot-mobile-left:${getMeasurementUnits(data.hotspot_left_mobile)}; --hotspot-mobile-top:${getMeasurementUnits(data.hotspot_top_mobile)};">
	 	<div class="icon-hotspot" >
			<svg role="application" aria-label="hotspot" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true"><path d="M0 0h24v24H0z" fill="none"></path><path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" fill="#ffffff"></path></svg>
		</div>
		<div class="stl--hotspot-popup" aria-label="${data.hotspot_title}" data-bg-color="white" data-ht-element="stl-popup-${data.index}">
			<a class="p6" href="${data.hotspot_url}">
				<img class="stl--hotspot-image" src="${data.hotspot_image}" alt="Hotspot Image}">
			</a>
			<div class="popup--text-container">
				<div class="t5" data-color="night-sky-dark">${data.hotspot_title}</div>
				<a class="p6" data-color="night-sky-dark" data-ht-element="stl-popup-cta-${data.index}"href="${data.hotspot_url}">${data.hotspot_cta || 'View Product'}</a>
			</div>
		</div>
	  </div>`;
}
